import { flickitySliderBySelector } from '@molecules/flickity-continuous-slider';
import { stickyCta } from './sticky-cta';
import 'lite-youtube-embed';

export const initHome = () => {
  if (!document.querySelector('#home')) {
    return;
  }

  stickyCta('.home-sticky', '.home-hero__ctas', 'home-sticky');
  flickitySliderBySelector('.home-components-customers');
};
